// extracted by mini-css-extract-plugin
module.exports = {"container":"_3GQpe","header":"f06c5","content":"_3ZOpP","controls":"_3eHZH"};